import {
  AfterViewInit,
  Component,
  Input,
  ViewChild,
  ViewContainerRef,
} from '@angular/core';

import assert from 'tiny-invariant';

import { FormlyTemplateOptions } from '@ngx-formly/core';

// Default change detection, like the label and validation-message leaves:
// formly writes a `props.description` expression into the same props object,
// so an OnPush leaf would never see it change (#11184).
@Component({
  selector: 'ts-ion-form-field-help-ui',
  templateUrl: './ion-form-field-help-ui.component.html',
  styleUrls: ['./ion-form-field-help-ui.component.scss'],
  standalone: false,
})
export class IonFormFieldHelpUiComponent implements AfterViewInit {
  @Input({ required: true }) props!: FormlyTemplateOptions;

  @ViewChild('helpTextContainer', { read: ViewContainerRef })
  helpTextViewContainerRef?: ViewContainerRef;

  ngAfterViewInit() {
    if (this.props['helpComponent']) {
      assert(this.helpTextViewContainerRef);
      this.helpTextViewContainerRef.createComponent(
        this.props['helpComponent'],
      );
    }
  }
}
